<div class="animated fadeIn">

    <div class="banner-container">
        <div class="container">
            @if(step <= 4) {
                <mnf-dashboard-v2-banner     
                    [title]="bannerDashboard[0].title"
                    [description]="bannerDashboard[0].description"
                    [image]="bannerDashboard[0].image"
                    [button]="bannerDashboard[0].button"
                    [routerLink]="bannerDashboard[0].routerLink">
                </mnf-dashboard-v2-banner>
            } @else if (step >=5) {
                <mnf-dashboard-v2-banner
                    [title]="bannerDashboard[1].title"
                    [description]="bannerDashboard[1].description"
                    [image]="bannerDashboard[1].image"
                    [button]="bannerDashboard[1].button"
                    [routerLink]="bannerDashboard[1].routerLink">
                </mnf-dashboard-v2-banner>
            }
        </div>
    </div>

    <div class="container">
        <div class="mt-3 mb-5 slides px-3 pt-lg-4 pb-4">
            <mnf-dashboard-v2-slides [status]="status"></mnf-dashboard-v2-slides>
        </div>
    </div>
</div>